import React from 'react';
import './Footer.scss';


export default (props) => {
	// <div className={ props.isAuthenticated ? "Footer" : "FooterLogin"}>
    //     Powered by <a href="https://www.ipsum365.com">Ipsum365 Ltd</a> &nbsp;						
	// </div>
	return(
	(localStorage.getItem('user')) ? 
		<div className="Footer">
        Powered by <a href="https://www.ipsum365.com">Ipsum365 Ltd</a> &nbsp;						
		</div>
		: 
		<div className="FooterLogin"></div>
 )};
